import { render, staticRenderFns } from "./PasswordOnly.vue?vue&type=template&id=dbb598a8&scoped=true&"
import script from "./PasswordOnly.vue?vue&type=script&lang=js&"
export * from "./PasswordOnly.vue?vue&type=script&lang=js&"
import style0 from "./PasswordOnly.vue?vue&type=style&index=0&id=dbb598a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb598a8",
  null
  
)

export default component.exports